module.exports = {
  "app": {
    "position": "relative",
    "width": "750",
    "justifyContent": "center",
    "alignItems": "center",
    "overflow": "hidden"
  },
  "cell_div_box": {
    "display": "flex",
    "alignItems": "stretch",
    "flexWrap": "nowrap",
    "flexDirection": "row",
    "marginBottom": "4"
  },
  "cell1": {
    "alignItems": "stretch",
    "width": "750"
  },
  "button_style": {
    "width": "160",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "button_text": {
    "marginLeft": "32",
    "marginRight": "32",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "threeLeftButton": {
    "display": "flex",
    "alignItems": "stretch",
    "flexDirection": "row"
  },
  "threeRightButton": {
    "display": "flex",
    "alignItems": "stretch",
    "flexDirection": "row"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-0973c3ee!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-swipe-cell/index.vue
// module id = 425
// module chunks = 0 1